import passport from './interfaces/passport'
import classMessage from './interfaces/classMessage'

export default {
    passport,
    classMessage
}